import { ValidatorFn, AbstractControl } from '@angular/forms';
/**
 * @return {?}
 */
export function NoDashValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    const /** @type {?} */ pattern: any = /^\-+$/;
    if (control.value && pattern.test(control.value.substr(0, 1))) {
      return { noDash: { value: control.value } };
    }
    return null;
  };
}
